module.exports = __webpack_public_path__ + "img/indexback.6c74c5b9.png";